<script setup lang="ts">
import { ref } from "vue";
import {useRouter} from "vue-router";
const value = ref("");
const password = ref("");
const yanzhengma = ref("");
const checked = ref(["a"]);
const router = useRouter();
const img = () => {
  // 处理验证码图片点击事件
};
import axios from "./../../utils/axios";
const login = () => {
  axios.post("/login",{
    "mobile" : value.value,
    "password" : password.value
  }).then((response)=>{
    if(response.code==0){
      localStorage.setItem("token", response.token);
      localStorage.setItem("user", response.user);
      // 成功登录后重定向首页
      router.push("/home");
    }
  });

};
</script>
<template>
  <div class="login">
    <div class="l_warp">
      <div class="warp_left">
        <div class="left_box">
          <div class="logo">
            <RouterLink to="/" class="a">
              <div class="lo_dv">
                <img src="./../../../public/66.png" alt="" />
              </div>
            </RouterLink>
          </div>
          <!-- 登陆表单 -->
          <van-cell-group class="group" inset>
            <van-field
              class="input_o"
              v-model="value"
              :placeholder="$t('system.login.placeholder')"
            />
            <van-field
              class="input_t"
              v-model="password"
              type="password"
              :placeholder="$t('system.login.password')"
            />
            <!--<div class="ding">-->
            <!--  <van-field class="input_th" v-model="yanzhengma" />-->
            <!--  <img @click="img()" src="./../../assets/imgs/下载.png" alt="" />-->
            <!--</div>-->
            <div class="fu_k">
              <van-checkbox-group class="K_j" v-model="checked" shape="square">
                <van-checkbox class="ji_zhu" name="a">{{
                  $t("system.login.jizhu")
                }}</van-checkbox>
              </van-checkbox-group>
              <van-button class="button" @click="login">{{
                $t("system.login.button")
              }}</van-button>
            </div>
            <hr style="margin-top: 80px" />
            <div class="text">{{ $t("system.login.text") }}</div>
            <div class="zhu_ce">
              <RouterLink to="./contact/Register">{{
                $t("system.login.zhuce")
              }}</RouterLink>
            </div>
          </van-cell-group>
        </div>
      </div>
      <div class="warp_right">
        <div class="right_box">
          <img src="./../../assets/imgs/login_01.jpg" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.l_warp {
  height: 100vh;
  position: relative;
  display: flex;
  flex-wrap: wrap;
}
.warp_left {
  overflow: hidden;
  box-sizing: border-box;
  flex: 1 0 0;
  padding: 4% 5%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.left_box {
  width: 100%;
  height: auto;
  max-width: 515px;
  margin: 0 auto;
}
.warp_right {
  width: 59.9%;
  height: 100%;
}
.right_box {
  padding-top: 0;
  height: 100%;
  display: block;
  position: relative;
  overflow: hidden;
}
.right_box img {
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  top:0;
  left: 0;
  object-fit: cover;
  transition: all 0.6s linear;
}
.logo .a {
  min-width: 120px;
  min-height: 120px;
  text-decoration: none;
  outline: none;
  color: #3e3a39;
}
.lo_dv {
  display: flex;
}
.logo .a img {
  vertical-align:middle;
  width: 420px;
  height: 76px;
}

img {
  border: none;
  display: inline-block;
  max-width: 100%;
}
.group {
  padding-top: 10px;
}
.input_o,
.input_t {
  padding: 0px;
  width: 100%;
  height: 50px;
  line-height: 50px;
  color: #141110;
  border-bottom: 1px solid #cccccc;
}
.in_img {
  width: 100%;
  height: 50px;
  line-height: 50px;
  display: flex;
  justify-content: space-between;
}
.input_th {
  padding: 0px;
  width: 60%;
  line-height: 70px;
  height: 50px;
  border-bottom: 1px solid #cccccc;
}
.ding {
  position: relative;
}
.group img {
  position: absolute;
  width: 120px;
  height: 40px;
  bottom: -10px;
  right: -30px;
  cursor: pointer;
}
.fu_k {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 35px;
  margin-top: 20px;
}

.ji_zhu {
  width: auto;
  height: 100%;
  font-size: 14px;
}
.button {
  color: #fff;
  background-color:#3c93cc;
  font-weight: bold;
  border-radius: 5px;
  height: 35px;
  line-height: 35px;
  min-width: 100px;
}
.text {
  font-size: 28px;
  padding: 8px 0;
  font-weight: 500;
  color: #3e3a39;
  text-align: center;
}
.zhu_ce {
  width: auto;
  height: 30px;
  margin: 20px auto;
  padding-top: 50px;
  line-height: 30px;
  text-align: center;
}
.zhu_ce a {
  text-decoration: none;
  border-bottom: 1px #3e3a39 solid;
  color: #3c93cc;
}
.van-checkbox__icon {
  box-shadow: 0px 1px 2px 0px rgba(125, 126, 128, 0.81);
  border-radius: 1px;
}
</style>
